module.exports = __webpack_public_path__ + "media/images/pathway_illustrations/PARAMEDIC SCIENCE-b60a873def1537d76b5a42b5f01804c0.png";